module.exports = __webpack_public_path__ + "img/first-board.a2aae35e.png";